import { render, staticRenderFns } from "./TabSecondary.vue?vue&type=template&id=55183a3a&scoped=true&"
import script from "./TabSecondary.vue?vue&type=script&lang=js&"
export * from "./TabSecondary.vue?vue&type=script&lang=js&"
import style0 from "./TabSecondary.vue?vue&type=style&index=0&id=55183a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55183a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55183a3a')) {
      api.createRecord('55183a3a', component.options)
    } else {
      api.reload('55183a3a', component.options)
    }
    module.hot.accept("./TabSecondary.vue?vue&type=template&id=55183a3a&scoped=true&", function () {
      api.rerender('55183a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/TabSecondary.vue"
export default component.exports